<template>
  <rule-form
    :rule-id="ruleId"
    :transaction-type="transactionType"
  />
</template>

<script>
  export default {
    name: 'EditRule',

    components: {
      RuleForm: () => import('../components/RuleForm'),
    },

    props: {
      ruleId: String,
      transactionType: String,
    },
  }
</script>
